export default import.meta.ROLLDOWN_FILE_URL_2X9RIBNDO30ulRXxNCcA3w